import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { DatabaseService } from '@app/database/database.service';


@Component({
  selector: 'app-print-footer',
  templateUrl: './print-footer.component.html',
  styleUrls: ['./print-footer.component.scss']
})
export class PrintFooterComponent implements OnInit {
  @Input() firmaB64: any;
  @Input() medicoFirmaB64: any;
  @Input() trabajadorApellidoNombre: string;
  @Input() medicoNombre: string;
  @Input() medicoEspecialidad: string;
  @Input() medicoMatricula: string;
  firmaMedico: SafeResourceUrl;
  firmaTrabajador: SafeResourceUrl;
  especialidades: any;
  especialidad: any;

  constructor(private sanitizer: DomSanitizer, private databaseService: DatabaseService) {}

  ngOnInit(): void {
    this.getFirmaUrl();
    this.getEspecialidades();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getFirmaUrl();
    this.getEspecialidades();
  }

  getFirmaUrl() {
    this.firmaMedico =  this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64,${this.medicoFirmaB64}`);
    this.firmaTrabajador = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64,${this.firmaB64}`);
  }

  // ESPECIALIDADES
  async getEspecialidades(): Promise<void> {
    const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
    this.especialidades = especialidadesListFromOffline
    if (this.medicoEspecialidad){
      const esp = this.especialidades.find(especialidades => especialidades.codigo === this.medicoEspecialidad);
      this.especialidad = esp.descripcion;
    }
  }


}
